import React from "react";

import { DaySettings } from "@/components/molecules/DaySettings/DaySettings";

import { orderedWorkDays } from "@/utils/UWorkDays";

import { TDayName, TDaysSettings } from "@/types";

type TWorkDays = TDaysSettings;

export interface IWorkDaysEditorProps {
	workDays: TWorkDays | undefined;
	/** The daily default a day switched on without hours inherits. */
	hoursPerDay?: string;
	onChange: (day: TDayName, value: TWorkDays[TDayName]) => void;
}

/**
 * One row per day - switch and hours - on plain props, so it works
 * under the app's Formik (DaysSettings) as well as inside an amphore
 * form, whose Formik copy has a context of its own.
 */
export const WorkDaysEditor: React.FC<IWorkDaysEditorProps> = ({
	workDays,
	hoursPerDay,
	onChange,
}) => {
	// The whole day goes back, not just the switch: this used to write
	// isWorkingDay alone, so the hours typed in a row never reached the
	// form and every day saved at whatever the API had. A day switched on
	// with no hours yet ("00:00" is what DaySettings reports for an unset
	// day) inherits the daily default, as the onboarding step does.
	const handleChange = (
		day: TDayName,
		hours: string,
		isWorkingDay: boolean
	) => {
		const unset = !hours || hours === "00:00";
		onChange(day, {
			hours: isWorkingDay && unset && hoursPerDay ? hoursPerDay : hours,
			isWorkingDay,
		});
	};

	return (
		<div className="max-w-[300px] space-y-2">
			{orderedWorkDays(workDays).map(([day, settings]) => (
				<DaySettings
					key={day}
					day={day}
					hours={settings.hours}
					isWorkingDay={settings.isWorkingDay}
					onChange={handleChange}
				/>
			))}
		</div>
	);
};
